import * as React from 'react';
import { useInView } from 'react-intersection-observer';

import {
  RoutineByCatalogIdQuery,
  ProductRoutineAssetEnum,
} from '@notino/shared/definitions/types';

import { RectanglePlaceholder } from '@components/Placeholders';

import { IProductsCount } from './model';
import {
  Header,
  Asset,
  Content,
  Title,
  Description,
} from './styled/RoutineHeader';

export const youtubeIframe = (src: string) => `
  <iframe
    src="${src}"
    frameborder="0"
    allowfullscreen
  ></iframe>`;

export const RoutineHeader: React.FC<
  Omit<
    RoutineByCatalogIdQuery['RoutineByCatalogId']['routine'][number],
    'products'
  > &
    IProductsCount
> = ({ title, description, asset, productsCount }) => {
  const [ref, inView] = useInView({ triggerOnce: true });

  return (
    <Header productsCount={productsCount}>
      {asset?.src?.length && (
        <Asset ref={ref} productsCount={productsCount}>
          {asset.type === ProductRoutineAssetEnum.Image ? (
            inView ? (
              <img src={asset.src} alt={asset.alt} />
            ) : (
              <RectanglePlaceholder />
            )
          ) : (
            <div
              dangerouslySetInnerHTML={{ __html: youtubeIframe(asset.src) }}
            />
          )}
        </Asset>
      )}
      <Content productsCount={productsCount} isAsset={!!asset}>
        <Title dangerouslySetInnerHTML={{ __html: title }} />
        <Description>{description}</Description>
      </Content>
    </Header>
  );
};
